import React, { useState, useEffect } from "react";
import { TextInput } from "../../Components/Inputs";
import init_supplier from "../init_supplier";
import Btn from "../../../../Components/Buttons/Btn";
import { useNavigate } from "react-router-dom";
import useAxios from "../../../../Hooks/useAxios";
import useForm from "../../Components/hooks/useForm";

const AddSupplier = () => {
  const [input, setInput] = useState(init_supplier);
  const navigate = useNavigate();
  const request = useAxios();

  // Debug: Log input changes
  useEffect(() => {
    console.log("🔄 Input state updated:", input);
    console.log("📝 Name field value:", input.name.value);
  }, [input]);

  const handleSubmit = async (data) => {
    console.log("🚀 handleSubmit called with data:", data);
    
    // Handle if useForm passes incorrect data structure
    if (!data || typeof data !== 'object') {
      console.error("❌ Invalid data from useForm:", data);
      alert("Form data is invalid. Please check your inputs.");
      return;
    }
    
    // Extract values safely - handle both nested and flat structures
    const extractFieldValue = (field) => {
      if (!field) return null;
      if (typeof field === 'object' && field.value !== undefined) {
        return field.value || null;
      }
      return field || null;
    };
    
    const payload = {
      name: extractFieldValue(data.name),
      company: extractFieldValue(data.company),
      email: extractFieldValue(data.email),
      phone: extractFieldValue(data.phone),
      address: extractFieldValue(data.address),
    };
    
    console.log("📤 Payload to send to backend:", payload);
    
    try {
      const res = await request({
        method: "POST",
        url: "suppliers/add",
        body: payload,
      });
      
      if (res === "error") {
        console.error("❌ Request failed");
        return;
      }
      
      console.log("✅ Supplier created successfully:", res);
      navigate("/dashboard/suppliers");
      
    } catch (error) {
      console.error("❌ Error in request:", error);
    }
  };

  const { handleValidation, validate } = useForm({
    input,
    submit: handleSubmit,
  });

  // Direct test function to bypass form validation issues
  const handleDirectSubmit = async () => {
    console.log("🔧 Testing direct submit...");
    
    // Get current values directly from state
    const testPayload = {
      name: input.name.value || "Test Supplier",
      company: input.company.value || null,
      email: input.email.value || null,
      phone: input.phone.value || null,
      address: input.address.value || null,
    };
    
    console.log("📤 Direct test payload:", testPayload);
    
    try {
      const res = await request({
        method: "POST",
        url: "suppliers/add",
        body: testPayload,
      });
      
      if (res === "error") {
        console.error("❌ Direct test failed");
        return;
      }
      
      console.log("✅ Direct test successful:", res);
      navigate("/dashboard/suppliers");
      
    } catch (error) {
      console.error("❌ Direct test error:", error);
    }
  };

  return (
    <div className="shadow-2xl w-[85%] m-auto border-t p-4 mt-12 rounded-md">
      <h3 className="text-center text-xl font-semibold">Add Supplier</h3>
      
      <div className="mt-4 flex flex-col gap-4">
        <TextInput
          input={input}
          setInput={setInput}
          field="name"
          validate={validate}
        />
        <TextInput
          input={input}
          setInput={setInput}
          field="company"
          validate={validate}
        />
        <TextInput
          input={input}
          setInput={setInput}
          field="email"
          validate={validate}
        />
        <TextInput
          input={input}
          setInput={setInput}
          field="phone"
          validate={validate}
        />
        <TextInput
          input={input}
          setInput={setInput}
          field="address"
          validate={validate}
        />
      </div>
      
      <div className="mt-4 flex justify-between">
        <Btn 
          onClick={() => navigate("/dashboard/suppliers")}
          className="bg-gray-500 hover:bg-gray-600"
        >
          Back
        </Btn>
        
        <div className="flex gap-2">
          <Btn 
            onClick={handleDirectSubmit}
            className="bg-yellow-500 hover:bg-yellow-600"
          >
            Test Submit
          </Btn>
          
          <Btn 
            onClick={handleValidation}
            className="bg-blue-500 hover:bg-blue-600"
          >
            Submit Form
          </Btn>
        </div>
      </div>
    </div>
  );
};

export default AddSupplier;